// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsPushResult = objectOf({
  daily_push_stats: objectOf({
    legacy_sent_count_by_hour: arrayOf(arrayOf(number)),
    legacy_open_count_by_hour: arrayOf(arrayOf(number)),
    legacy_bounce_count_by_hour: arrayOf(arrayOf(number)),
    ios_sent_count_by_hour: arrayOf(arrayOf(number)),
    ios_influenced_open_count_by_hour: arrayOf(arrayOf(number)),
    ios_open_count_by_hour: arrayOf(arrayOf(number)),
    ios_bounce_count_by_hour: arrayOf(arrayOf(number)),
    android_sent_count_by_hour: arrayOf(arrayOf(number)),
    android_influenced_open_count_by_hour: arrayOf(arrayOf(number)),
    android_open_count_by_hour: arrayOf(arrayOf(number)),
    android_bounce_count_by_hour: arrayOf(arrayOf(number)),
    kindle_sent_count_by_hour: arrayOf(arrayOf(number)),
    kindle_influenced_open_count_by_hour: arrayOf(arrayOf(number)),
    kindle_open_count_by_hour: arrayOf(arrayOf(number)),
    kindle_bounce_count_by_hour: arrayOf(arrayOf(number)),
    web_sent_count_by_hour: arrayOf(arrayOf(number)),
    web_influenced_open_count_by_hour: arrayOf(arrayOf(number)),
    web_open_count_by_hour: arrayOf(arrayOf(number)),
    web_bounce_count_by_hour: arrayOf(arrayOf(number)),
  }),
});
